export default __webpack_public_path__ + "static/media/twitter (1).fd54f0e8.svg";